import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type Tom = "neutro" | "dourado" | "sucesso" | "alerta" | "perigo";
const tons: Record<Tom, string> = {
  neutro: "bg-neutral-100 text-neutral-700",
  dourado: "bg-gold-100 text-gold-800",
  sucesso: "bg-success-100 text-success-500",
  alerta: "bg-warning-100 text-warning-500",
  perigo: "bg-danger-100 text-danger-500",
};

export function Selo({
  tom = "neutro",
  children,
  className,
  cor,
}: {
  tom?: Tom;
  children: ReactNode;
  className?: string;
  cor?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex h-5 items-center gap-1 whitespace-nowrap rounded-full px-2 text-[11px] font-semibold",
        !cor && tons[tom],
        className,
      )}
      style={cor ? { backgroundColor: `${cor}22`, color: textoLegivel(cor) } : undefined}
    >
      {children}
    </span>
  );
}

/** Cor da etiqueta escurecida até 4,5:1 sobre o próprio fundo claro (AA). */
function textoLegivel(cor: string): string {
  const m = /^#([0-9a-f]{6})$/i.exec(cor);
  if (!m) return cor;
  const rgb = [0, 2, 4].map((i) => parseInt(m[1]!.slice(i, i + 2), 16));
  const lum = (c: number[]) => {
    const f = (v: number) => {
      const x = v / 255;
      return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * f(c[0]!) + 0.7152 * f(c[1]!) + 0.0722 * f(c[2]!);
  };
  // Fundo: a cor a 13% sobre branco.
  const fundo = lum(rgb.map((v) => Math.round(255 - (255 - v) * 0.133)));
  for (let k = 0; k <= 1; k += 0.05) {
    const c = rgb.map((v) => Math.round(v * (1 - k)));
    if ((fundo + 0.05) / (lum(c) + 0.05) >= 5.4) return `rgb(${c.join(",")})`; // folga: linha selecionada é mais escura
  }
  return "#000";
}
